import { render, staticRenderFns } from "./OrderReceipt.vue?vue&type=template&id=65e93859&scoped=true"
import script from "./OrderReceipt.vue?vue&type=script&lang=js"
export * from "./OrderReceipt.vue?vue&type=script&lang=js"
import style0 from "./OrderReceipt.vue?vue&type=style&index=0&id=65e93859&prod&lang=css"
import style1 from "./OrderReceipt.vue?vue&type=style&index=1&id=65e93859&prod&lang=scss&scoped=true"
import style2 from "./OrderReceipt.vue?vue&type=style&index=2&id=65e93859&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e93859",
  null
  
)

export default component.exports